if (typeof jQuery === "undefined") {
    throw new Error("MazakaCore requires jQuery");
}

$.Counter = {
    Starter: function (that) {
        function getTimeRemaining(endtime) {
            var t = Date.parse(endtime) - Date.parse(new Date());
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            //var days = Math.floor(t / (1000 * 60 * 60 * 24));
            return {
                total: t,
                //'days': days,
                hours: hours,
                minutes: minutes,
                seconds: seconds,
            };
        }

        function initializeClock(id, endtime) {
            var clock = document.getElementById(id);
            //var daysSpan = clock.querySelector('.days');
            var hoursSpan = clock.querySelector(".hours");
            var minutesSpan = clock.querySelector(".minutes");
            var secondsSpan = clock.querySelector(".seconds");

            function updateClock() {
                var t = getTimeRemaining(endtime);

                //daysSpan.innerHTML = t.days;
                hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
                minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
                secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);

                if (t.total <= 0) {
                    clearInterval(timeinterval);
                }
            }

            updateClock();
            var timeinterval = setInterval(updateClock, 1000);
        }

        var deadline = new Date(Date.parse(new Date()));
        initializeClock("clockdiv", deadline);
    },
};

$.Cart = {
    IncDetail: function (that) {
        var addToCartAmount = $(that).parent().find("[name='addToCartAmount']");
        var startValue = parseFloat($(addToCartAmount).val());
        var increment = parseFloat(
            $.Util.ToNumber($(that).attr("data-increment"))
        );
        var dataMax = $(that).attr("data-max");
        var max = $.Util.ToNumber(dataMax);

        var maxCartQuantity = $(that).attr("data-maxCartQuantity");
        if (maxCartQuantity) {
            var maxQuantity = $.Util.ToNumber(maxCartQuantity);
            if (maxQuantity < max) {
                max = maxQuantity;
            }
        }
        var detailAmount = startValue + increment;
        if (dataMax && detailAmount > max) {
            const $errorModal = $("#errorModalAlertDiv");

            if ($errorModal.length) {
                $errorModal.addClass("stock-error");
                $errorModal.find(".error-modal-content").html(stockErrorLocalizer);
                $errorModal.modal("show");
            }
            return;
        }
        $(addToCartAmount).val($.Util.ToConvert(detailAmount));
        $(addToCartAmount).change();
    },
    DecDetail: function (that) {
        var addToCartAmount = $(that).parent().find("[name='addToCartAmount']");
        startValue = $(addToCartAmount).val();
        var decrement = $.Util.ToNumber($(that).attr("data-increment"));
        var minCartQuantity = $(that).attr("data-minCartQuantity");
        var minQuantity = $.Util.ToNumber(minCartQuantity);
        var isProductGroup = $(that).attr("group-product") === "true";
        if (isProductGroup) {
            if (startValue - decrement >= 0) {
                if (minQuantity) {
                    if (startValue - decrement >= minQuantity) {
                        startValue -= decrement;
                        $(addToCartAmount).val($.Util.ToConvert(startValue));
                    }
                } else {
                    startValue -= decrement;
                    $(addToCartAmount).val($.Util.ToConvert(startValue));
                }
            }
        } else {
            if (startValue - decrement > 0) {
                if (minQuantity) {
                    if (startValue - decrement >= minQuantity) {
                        startValue -= decrement;
                        $(addToCartAmount).val($.Util.ToConvert(startValue));
                    }
                } else {
                    startValue -= decrement;
                    $(addToCartAmount).val($.Util.ToConvert(startValue));
                }
            }
        }
        $(addToCartAmount).change();
    },
    AddCart: function (that) {
        if (
            marketMode &&
            marketMode == "True" &&
            !localStorage.getItem("deliveryAddressNames")
        ) {
            $(".select-location").trigger("click");
            $(".delivery-notifications").show();
            $(".close").click(function () {
                $(".modal-backdrop").fadeOut("fast");
            });
            $("#locationModal").change(function () {
                $(".modal-backdrop").fadeOut("fast");
            });

            return;
        }
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        if (addCartType === "cart") {
            var loadingCart = $(that).closest(".load").find(".loading");
            $(loadingCart).fadeIn("fast");
        } else if (addCartType === "popup") {
            $("#add-cart-modal .cart-modal-loading").show();
            $("#add-cart-modal .cart-modal-content").hide();
            $("#add-cart-modal").modal("show");
        } else {
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");
        }

        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var addToCartAmount =
            $(that)
                .closest(".add-cart")
                .find("[name='addToCartAmount']")
                .val() ||
            $(that).parent().find("[name='addToCartAmount']").val();
        var quantity = parseFloat(addToCartAmount);
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var image = $(that).attr("data-img");
        var name = $(that).attr("data-name");

        var price = $(that).attr("data-price-with-discount");
        var variantValues = $(that).attr("data-variant");
        var baseGroupProductName = $(that).attr("data-base-group-product-name");
        var baseGroupProductLink = $(that).attr("data-base-group-product-link");
        var baseGroupProductImg = $(that).attr("data-base-group-product-img");
        var warehouseId = $(
            "[data-id='" + productID + "'][id = 'warehouseId']"
        ).val();

        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity,
            AddCartType: addCartType,
            WarehouseId: warehouseId || undefined,
        };
        if (baseGroupProductName) {
            params["BaseGroupProductName"] = baseGroupProductName;
            params["BaseGroupProductLink"] = baseGroupProductLink;
            params["BaseGroupProductImage"] = baseGroupProductImg;
        }
        if (variantValues) {
            params.variantValues = JSON.parse(variantValues);
        }
        $.FacebookPixel.AddToCart(productCode, price);

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(
                function () {
                    $(that).attr("disabled", false);
                    if (addCartType === "cart") {
                        window.location = "/Cart/Index";
                    } else if (addCartType === "popup") {
                        $("#add-cart-modal .cart-modal-product-image").attr(
                            "src",
                            imageServer + "/" + image
                        );
                        $("#add-cart-modal .cart-modal-product-name").html(
                            name
                        );
                        $("#add-cart-modal #addCartQuantity").html(
                            parseFloat(addToCartAmount)
                        );
                        $("#add-cart-modal .cart-modal-message").show();

                        $("#add-cart-modal .error_text").hide();
                        $("#add-cart-modal .cart-modal-loading").hide();
                        $("#add-cart-modal .cart-modal-content").show();
                    } else {
                        $(cart).fadeIn("fast");
                        $(loading).fadeOut("fast");
                        var success = $(that)
                            .closest(".border-urun")
                            .find(".SuccessText");
                        $(success).fadeIn("fast").delay(1000).fadeOut("fast");
                    }
                },
                function (error) {
                    $(that).attr("disabled", false);
                    if (addCartType === "popup") {
                        $("#add-cart-modal .cart-modal-loading").hide();
                        $("#add-cart-modal").modal("hide");
                        $("#add-cart-modal .cart-modal-product-image").attr(
                            "src",
                            imageServer + "/" + image
                        );
                        $("#add-cart-modal .cart-modal-product-name").addClass(
                            "errorClass"
                        );
                        $("#add-cart-modal .cart-modal-product-name").html(
                            error
                        );
                        $("#add-cart-modal .cart-modal-message").hide();
                        $("#add-cart-modal .error_text").show();
                        $("#add-cart-modal #addCartQuantity").hide();

                        $("#add-cart-modal .cart-modal-content").show();
                    } else if (addCartType === "cart") {
                    } else {

                        $("#add-cart-modal").modal("show");
                        $("#add-cart-modal .user-cart__cart-added-modal__dialog").css("max-width", "300px")
                        $("#add-cart-modal .cart-modal-loading").hide();
                        $(".user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box").addClass("d-none");
                        $("#add-cart-modal .modal-body").html(error.toString().split(':')[1]);
                        $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__header").removeClass("justify-content-between");
                        $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__header").addClass("justify-content-center");
                        $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__modal-header__button").addClass("errorClassCloseButton");
                        $("#add-cart-modal .modal-content").addClass("errorClass");
                        $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__navigation-links").removeClass("d-flex");
                        $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__navigation-links").hide();
                        // $("#add-cart-modal .user-cart__cart-added-modal__dialog__content__body__product-info__name-box__added-text-box__text").html(
                        //     error.toString().split(':')[1]
                        // );
                        $(cart).fadeIn("fast");
                        $(loading).fadeOut("fast");
                    }
                }
            );
    },
    AddFavorite: function (that, callback) {
        $(".account-containerv2-guest").show();
        $(".account-containerv2").hide();
        if (!userId) {
            if ($("#accountModal").length > 0) {
                $("#accountModal").modal("show");
                angular.element(".account-controller").scope().vm.cartCallback = that;
            } else {
                window.location = "/account/loginorsignup?ReturnUrl=" + window.location.href;
                return;
            }
        } else {
            $(that).attr("disabled", true);
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");

            var params = {
                productID: productID,
                CartType: "Favorite",
            };

            return angular
                .element(".cart-controller")
                .scope()
                .vm.InsertWithParams(params)
                .then(function (result) {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that)
                        .closest(".border-urun")
                        .find(".FavoriteText");
                    $(success).fadeIn("fast").delay(1000).fadeOut("fast");
                    if (callback) {
                        callback(that);
                    }
                    return result;
                });
        }
    },
    GoFavorite: function (that, e) {
        e.preventDefault();
        var charCulture = encodeURIComponent($(that).attr("culture"));
        if (!userId) {
            if (
                $("#userAccountDrawer").length > 0 ||
                $("#userAccount").length > 0
            ) {
                $("#userAccount").modal("show");
                $("#userAccountDrawer").toggleClass("end-0");
                $(".user-account__backdrop-shade").toggleClass(
                    "end-0 col-12 top-0"
                );
                return false;
            } else {
                window.location =
                    "/account/loginorsignup?ReturnUrl=" + window.location.href;
                return false;
            }
        } else {
            window.location =
                (charCulture ? "/" + charCulture : "") + "/Cart/Favorite";
            return true;
        }
    },
    AddCompare: function (that, callback) {
        $(that).attr("disabled", true);
        var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
        var loading = $(that).closest(".load").find(".loading");
        $(cart).fadeOut("fast");
        $(loading).fadeIn("fast");

        var productID = $(that).attr("data-id");

        var params = {
            productID: productID,
            CartType: "Compare",
            Quantity: 1,
        };

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(
                function () {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that)
                        .closest(".border-urun")
                        .find(".SuccessText");
                    $(success).fadeIn("fast").delay(1000).fadeOut("fast");
                    callback(that);
                },
                function (data) {
                    angular
                        .element(".cart-controller")
                        .scope().vm.loading = false;
                    $("#errorModalAlertDiv").modal("show");
                    $("#errorModalAlertDiv .error-modal-content").html(
                        basketErrorLocalizer
                    );
                }
            );
    },
    AddStock: function (that, callback) {
        $(".account-containerv2-guest").show();
        $(".account-containerv2").hide();
        if (!userId) {
            if (
                $("#userAccountDrawer").length > 0 ||
                $("#accountModal").length > 0
            ) {
                $("#accountModal").modal("show");
                window.cartCallback = that;
                $("#userAccountDrawer").toggleClass("end-0");
                $(".user-account__backdrop-shade").toggleClass(
                    "end-0 col-12 top-0"
                );
                return false;
            } else {
                window.location =
                    "/account/loginorsignup?ReturnUrl=" + window.location.href;
                return false;
            }
        } else {
            $(that).attr("disabled", true);
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");

            var params = {
                productID: productID,
                CartType: "Stock",
                quantity: 1,
            };

            return angular
                .element(".cart-controller")
                .scope()
                .vm.InsertWithParams(params)
                .then(function () {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that)
                        .closest(".border-urun")
                        .find(".SuccessText");
                    $(success).fadeIn("fast").delay(1000).fadeOut("fast");
                    callback(that);
                });
        }
    },
    AddDiscount: function (that, callback) {
        $(".account-containerv2-guest").show();
        $(".account-containerv2").hide();
        if (!userId) {
            if (
                $("#userAccountDrawer").length > 0 ||
                $("#accountModal").length > 0
            ) {
                $("#accountModal").modal("show");
                window.cartCallback = that;
                $("#userAccountDrawer").toggleClass("end-0");
                $(".user-account__backdrop-shade").toggleClass(
                    "end-0 col-12 top-0"
                );
                return false;
            } else {
                window.location =
                    "/account/loginorsignup?ReturnUrl=" + window.location.href;
                return false;
            }
        } else {
            $(that).attr("disabled", true);
            var cart = $(that).closest(".index-pro").find(".btnAddToBasket");
            var loading = $(that).closest(".load").find(".loading");
            $(cart).fadeOut("fast");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");

            var params = {
                productID: productID,
                CartType: "Discount",
                Quantity: 1,
            };
            return angular
                .element(".cart-controller")
                .scope()
                .vm.InsertWithParams(params)
                .then(function () {
                    $(that).attr("disabled", false);
                    $(cart).fadeIn("fast");
                    $(loading).fadeOut("fast");
                    var success = $(that)
                        .closest(".border-urun")
                        .find(".SuccessText");
                    $(success).fadeIn("fast").delay(3000).fadeOut("fast");
                    callback(that);
                });
        }
    },
    AddCartAndGo: function (that) {
        $(that).attr("disabled", true);
        var variantValues = $.Cart.GetVariantData(that);

        var loadingCart = $(that).closest(".load").find(".loading");
        $(loadingCart).fadeIn("fast");
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var addToCartAmount = $(that).parent().find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        var price = $(that).attr("data-price-with-discount");
        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity,
        };

        $.FacebookPixel.AddToCart(productCode, price);

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(
                function () {
                    $(that).attr("disabled", false);
                    window.location = "/Checkout/Checkout";
                },
                function (error) {
                    $(that).attr("disabled", false);
                    alert(error);
                }
            );
    },
    FastBuy: function (that) {
        $(that).attr("disabled", true);
        var variantValues = $.Cart.GetVariantData(that);

        var loadingCart = $(that).closest(".load").find(".loading");
        $(loadingCart).fadeIn("fast");
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var defaultQuantity = $.Util.ToNumber($(that).attr("data-quantity"));
        var addToCartAmount = $(that).parent().find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        var price = $(that).attr("data-price-with-discount");
        var params = {
            productID: productID,
            quantity: quantity || defaultQuantity,
        };

        $.FacebookPixel.AddToCart(productCode, price);

        return angular
            .element(".cart-controller")
            .scope()
            .vm.InsertWithParams(params)
            .then(
                function () {
                    $(that).attr("disabled", false);
                    window.location = "/Checkout/Checkout?fastBuy=true";
                },
                function (error) {
                    $(that).attr("disabled", false);
                    alert(error);
                }
            );
    },
    GetVariantData: function (that) {
        var variantValues = [];
        var variantFormData = $(that)
            .closest(".product-add-to-cart")
            .find(".variant-form .option-wrapper");

        $.each(variantFormData, function (i, item) {
            if ($(item).find("input:checked").attr("value-text")) {
                var key = $(item).find("input:checked").attr("name");
                var value = $(item).find("input:checked").attr("value-text");
                variantValues.push(value);
            }
            $.each($(item).find("select"), function (j, subitem) {
                if ($(subitem).find("option:selected").text()) {
                    var key = $(subitem).attr("name");
                    var value = $(subitem).find("option:selected").text();
                    variantValues[key] = value;
                }
            });
            $.each($(item).find("input[type='text']"), function (j, subitem) {
                if ($(subitem).val()) {
                    var key = $(subitem).attr("name");
                    var value = $(subitem).val();
                    variantValues[key] = value;
                }
            });
        });
        return variantValues;
    },
    AddCartDetail: function (that) {
        if (
            marketMode &&
            marketMode == "True" &&
            !localStorage.getItem("deliveryAddressNames")
        ) {
            $(".select-location").trigger("click");
            $(".delivery-notifications").show();
            $(".close").click(function () {
                $(".modal-backdrop").fadeOut("fast");
            });
            $("#locationModal").change(function () {
                $(".modal-backdrop").fadeOut("fast");
            });
            if ($("#locationModal").length <= 0) {
                locationError
                $("#errorModalAlertDiv").modal("show");
                $("#errorModalAlertDiv .error-modal-content").html(
                    locationAlertError
                );
            }
            return;
        }
        $(that).attr("disabled", true);
        var variantValues;
        if ($(that).attr("data-variant")) {
            variantValues = $(that).attr("data-variant");
        } else {
            variantValues = $.Cart.GetVariantData(that);
        }

        var addCartType = $("#CartController").attr("add-cart-loader");
        var detailLoader = $(that).find(".add-cart-detail-loader");
        $(detailLoader).removeClass("d-none");
        if (addCartType === "cart") {
            var loading = $(that)
                .closest(".product-add-to-cart")
                .find(".loading");
            $(loading).fadeIn("fast");
        } else if (addCartType === "popup") {
            $("#add-cart-modal .cart-modal-loading").show();
            $("#add-cart-modal .cart-modal-content").hide();
            $("#add-cart-modal").modal("show");
        }

        if (!$(that).hasClass("no-variant")) {
            var variantValues;
            if ($(that).attr("data-variant")) {
                variantValues = $(that).attr("data-variant");
            } else {
                variantValues = $.Cart.GetVariantData(that);
            }

            var addCartType = $("#CartController").attr("add-cart-type");
            if (addCartType === "cart") {
                var loading = $(that)
                    .closest(".product-add-to-cart")
                    .find(".loading");
                $(loading).fadeIn("fast");
            } else if (addCartType === "popup") {
                $("#add-cart-modal .cart-modal-loading").show();
                $("#add-cart-modal .cart-modal-content").hide();
                $("#add-cart-modal").modal("show");
            } else {
                var loadingCart = $(that)
                    .closest(".product-add-to-cart")
                    .find(".loading");
                $(loadingCart).fadeIn("fast");
            }

            var productID = $(that).attr("data-id");
            var tierPriceQuantity = $(that).attr("data-tier-price-quantity");
            var addToCartAmount = $(that)
                .parent()
                .find("[name='addToCartAmount'][data-id='" + productID + "']");
            var addToCartAmount2 = $(
                "[name='addToCartAmount'][data-id='" + productID + "']"
            );

            var dynamicQuantityAmount = $("#dynamicQuantityValue").val();
            var quantity = 1;
            if (isNaN(parseFloat(tierPriceQuantity)) == false) {
                quantity = parseFloat($(tierPriceQuantity).val());
            } else if (isNaN(parseFloat($(addToCartAmount).val()))) {
                quantity = parseFloat($(addToCartAmount2).val());
            } else {
                quantity = parseFloat($(addToCartAmount).val());
            }
            var dynamicQuantity = parseFloat(dynamicQuantityAmount);
            if ($(that).parent().find(".overage-control")) {
                var overage = parseFloat(
                    $(that).parent().find(".overage-control select").val() || 0
                );
                var quantity2 = parseFloat(
                    $(that)
                        .parent()
                        .find(".overage-control")
                        .parent()
                        .find("[name='addToCartAmount']")
                        .val() || 1
                );
                var newQuantity = Math.ceil(
                    quantity + (quantity * overage) / 100
                );
                quantity2 = newQuantity;
            }
            var defaultIncrement = $.Util.ToNumber(
                $(that).attr("data-increment")
            );
            if (quantity == 0 && $(".group-product-quantity").length > 0) {
                quantity += defaultIncrement;
                quantity2 = quantity;
            }
            var isGroupProduct;
            isGroupProduct = $(that).attr("data-group-product") == "true";
            var currency = $(that).attr("data-currency");
            var productCode = $(that).attr("data-code");
            var image = isGroupProduct
                ? $(that).attr("data-base-group-product-img")
                : $(that).attr("data-img");

            var analytics = null;

            if ($(that).attr("data-analytics"))
                analytics = JSON.parse($(that).attr("data-analytics"))
                    .products[0];

            var name = isGroupProduct
                ? $(that).attr("data-base-group-product-name")
                : $(that).attr("data-name");
            var defaultQuantity = $.Util.ToNumber(
                $(that).attr("data-quantity")
            );
            var price = $(that).attr("data-price-with-discount");
            var warehouseId = $(
                "[data-id='" + productID + "'][id = 'warehouseId']"
            ).val();

            $.FacebookPixel.AddToCart(productCode, price);


            var description = $(that).attr("data-description");
            var params = {
                productID: productID,
                quantity: quantity || defaultQuantity,
                dynamicQuantity: dynamicQuantity,
                WarehouseId: warehouseId || undefined,
                AddCartType: addCartType,
                Description: description
            };

            if (variantValues && variantValues.length != 0) {
                params.variantValues = variantValues;
            }

            var baseGroupProductName = $(that).attr(
                "data-base-group-product-name"
            );
            var baseGroupProductLink = $(that).attr(
                "data-base-group-product-link"
            );
            var baseGroupProductImg = $(that).attr(
                "data-base-group-product-img"
            );

            if (baseGroupProductName) {
                params["BaseGroupProductName"] = baseGroupProductName;
                params["BaseGroupProductLink"] = baseGroupProductLink;
                params["BaseGroupProductImage"] = baseGroupProductImg;
            }

            function formatCurrency(value, currency, locale = "tr-TR") {
                try {
                    var formatter = new Intl.NumberFormat(locale, {
                        style: "currency",
                        currency: currency
                    });

                    return formatter.format(value);
                } catch (error) {
                    console.error("Invalid currency code or locale:", error);
                    return value.toFixed(2) + " " + currency;
                }
            }

            var promiseInsertCart = (window.promiseInsertCart = angular
                .element("#CartController")
                .scope()
                .vm.InsertWithParams(params));

            promiseInsertCart.then(
                function () {
                    $(that).attr("disabled", false);
                    if (addCartType === "popup") {
                        $('.add-cart-detail-loader').addClass('d-none');
                        $("#add-cart-modal .cart-modal-product-image").attr(
                            "src",
                            imageServer + "/" + image
                        );
                        $(
                            "#add-cart-modal .user-cart_cart-added-modaldialogcontentbodyproduct-infoname-box_added-text-box svg"
                        ).show();
                        $(
                            "#add-cart-modal .user-cart_cart-added-modaldialogcontentbodyproduct-infoname-boxadded-text-box_text"
                        ).show();
                        $(
                            "#add-cart-modal .cart-modal-product-name"
                        ).removeClass("errorClass");

                        $("#add-cart-modal .error_text").hide();
                        $("#add-cart-modal .cart-modal-product-name").html(
                            name
                        );
                        $("#add-cart-modal .cart-modal-product-name").show();
                        $("#add-cart-modal #addCartQuantity").html(quantity);
                        $(
                            "#add-cart-modal .cart-modal-product-price-with-discount"
                        ).html(
                            formatCurrency(parseFloat(price.replace(",", ".")) * (quantity2 ? quantity2 : defaultQuantity), currency)
                        );
                        $(
                            "#add-cart-modal .cart-modal-product-price-with-quantity"
                        ).html(quantity2 ? quantity2 : defaultQuantity);
                        $("#add-cart-modal .cart-modal-loading").hide();
                        $("#add-cart-modal .cart-modal-content").show();
                        var loading = $(that)
                            .closest(".product-add-to-cart")
                            .find(".loading");
                        $(loading).fadeOut("fast");

                    } else if (addCartType === "cart") {
                        window.location = "/Cart/Index";
                    } else {


                        var success = $(that)
                            .closest(".product-add-to-cart")
                            .find(".SuccessTextDetail");
                        var loading = $(that)
                            .closest(".product-add-to-cart")
                            .find(".loading");
                        $(loading).fadeOut("fast");
                        $(success).fadeIn("fast").delay(1000).fadeOut("fast");
                        $(success).addClass("end-0");
                        //$(".quic-view").modal("hide");
                        //angular.element("#CartController").scope().vm.getCart();


                    }
                    $(detailLoader).addClass("d-none");
                },
                function (error) {
                    $(that).attr("disabled", false);
                    if (addCartType === "popup") {
                        $("#add-cart-modal .cart-modal-loading").hide();
                        $("#add-cart-modal").modal("hide");
                        $("#add-cart-modal .cart-modal-product-image").attr(
                            "src",
                            imageServer + "/" + image
                        );
                        $("#add-cart-modal .cart-modal-product-name").addClass(
                            "errorClass"
                        );
                        $("#add-cart-modal .cart-modal-product-name").html(
                            error
                        );
                        $(
                            "#add-cart-modal .user-cart_cart-added-modaldialogcontentbodyproduct-infoname-box_added-text-box svg"
                        ).hide();
                        $(
                            "#add-cart-modal .user-cart_cart-added-modaldialogcontentbodyproduct-infoname-boxadded-text-box_text"
                        ).hide();
                        $("#add-cart-modal .error_text").show();
                        $("#add-cart-modal #addCartQuantity").hide();

                        $("#add-cart-modal .cart-modal-content").show();
                    } else if (addCartType === "cart") {
                    } else {

                        /**/
                        $("#add-cart-modal").modal("show");
                        $("#add-cart-modal .modal-body").html(error.toString().split(':')[1] + `
                        <div class="user-cart_cart-added-modaldialogcontentbodyproduct-infoname-box_added-text-box cart-modal-success-icon d-flex gap-1 align-items-center justify-content-center d-none">
                        <span class="user-cart_cart-added-modaldialogcontentbodyproduct-infoname-boxadded-text-box_text">Complementary  Products</span>
                    </div>
`);

                        $("#add-cart-modal .modal-header").html();
                        $("#add-cart-modal .user-cart_cart-added-modal_dialog").css("max-width", "200px");
                        $(".user-cart_cart-added-modaldialogcontentbodyproduct-infoname-boxadded-text-box_text").css("display", "");
                        //user - cart_cart - added - modaldialogcontentmodal - header_button
                        $(".user-cart_cart-added-modaldialogcontentmodal-header_button").removeClass("d-none");
                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontentbodyproduct-infoname-boxadded-text-box_text:before").css("content", "none");
                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontent_header").removeClass("justify-content-between");
                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontent_header").addClass("justify-content-center");

                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontentmodal-header_button").addClass("errorClassCloseButton");
                        $("#add-cart-modal .cart-modal-loading").hide();
                        $("#add-cart-modal .modal-content").addClass("errorClass");
                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontentbody_navigation-links").removeClass("d-flex");
                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontentbody_navigation-links").hide();
                        $("#add-cart-modal .user-cart_cart-added-modaldialogcontentbodyproduct-infoname-boxadded-text-box_text").hide();
                        var loading = $(that)
                            .closest(".product-add-to-cart")
                            .find(".loading");
                        $(loading).fadeOut("fast");
                    }
                    $(detailLoader).addClass("d-none");
                }
            );
        } else {

            $(that).attr("disabled", false);
            $("#errorModalAlertDiv").modal("show");
            $("#errorModalAlertDiv .error-modal-content").html(
                variantSelectError
            );
        }
        $(that).attr("disabled", false);
    },
    AddCartAndGoDetail: function (that) {
        if (!$(that).hasClass("no-variant")) {
            $(that).attr("disabled", true);
            var addCartType = $("#CartController").attr("add-cart-type");
            var loading = $(that)
                .closest(".product-add-to-cart")
                .find(".loading");
            $(loading).fadeIn("fast");

            var productID = $(that).attr("data-id");
            var addToCartAmount = $(that)
                .parent()
                .find("[name='addToCartAmount'][data-id='" + productID + "']");
            var quantity = parseFloat($(addToCartAmount).val());
            if ($(that).parent().find(".overage-control")) {
                var overage = parseFloat(
                    $(that).parent().find(".overage-control select").val() || 0
                );
                var quantity2 = parseFloat(
                    $(that)
                        .parent()
                        .find(".overage-control")
                        .parent()
                        .find("[name='addToCartAmount']")
                        .val() || 1
                );
                var newQuantity = Math.ceil(
                    quantity + (quantity * overage) / 100
                );
                quantity2 = newQuantity;
            }
            var productCode = $(that).attr("data-code");
            var warehouseId = $(
                "[data-id='" + productID + "'][id = 'warehouseId']"
            ).val();
            var price = $(that).attr("data-price-with-discount");
            $.FacebookPixel.AddToCart(productID, price);

            var params = {
                productID: productID,
                quantity: quantity,
                WarehouseId: warehouseId || undefined,
            };

            return angular
                .element("#CartController")
                .scope()
                .vm.InsertWithParams(params)
                .then(
                    function () {
                        $(that).attr("disabled", false);
                        window.location = "/Checkout/Checkout";
                    },
                    function (error) {
                        $(that).attr("disabled", false);
                        alert(error);
                    }
                );
        } else {
            $("#errorModalAlertDiv").modal("show");
            $("#errorModalAlertDiv .error-modal-content").html(
                variantSelectError
            );
        }
    },
    FastBuyDetail: function (that) {
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        var loading = $(that).closest(".product-add-to-cart").find(".loading");
        $(loading).fadeIn("fast");

        var addToCartAmount = $(that).parent().find("[name='addToCartAmount']");
        var quantity = parseFloat($(addToCartAmount).val());
        if ($(that).parent().find(".overage-control")) {
            var overage = parseFloat(
                $(that).parent().find(".overage-control select").val() || 0
            );
            var quantity2 = parseFloat(
                $(that)
                    .parent()
                    .find(".overage-control")
                    .parent()
                    .find("[name='addToCartAmount']")
                    .val() || 1
            );
            var newQuantity = Math.ceil(quantity + (quantity * overage) / 100);
            quantity2 = newQuantity;
        }
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var price = $(that).attr("data-price-with-discount");
        $.FacebookPixel.AddToCart(productID, price);

        var params = {
            productID: productID,
            quantity: quantity,
        };

        return angular
            .element("#CartController")
            .scope()
            .vm.InsertWithParams(params)
            .then(
                function () {
                    $(that).attr("disabled", false);
                    window.location = "/Checkout/Checkout?fastBuy=true";
                },
                function (error) {
                    $(that).attr("disabled", false);
                    alert(error);
                }
            );
    },
    FastBuyTPDetail: function (that) {
        $(that).attr("disabled", true);
        var addCartType = $("#CartController").attr("add-cart-type");
        var loading = $(that).closest(".product-add-to-cart").find(".loading");
        $(loading).fadeIn("fast");

        var quantity = parseFloat($(that).attr("data-quantity"));

        if ($(that).parent().find(".overage-control")) {
            var overage = parseFloat(
                $(that).parent().find(".overage-control select").val() || 0
            );
            var quantity2 = parseFloat(
                $(that)
                    .parent()
                    .find(".overage-control")
                    .parent()
                    .find("[name='addToCartAmount']")
                    .val() || 1
            );
            var newQuantity = Math.ceil(quantity + (quantity * overage) / 100);
            quantity2 = newQuantity;
        }
        var productID = $(that).attr("data-id");
        var productCode = $(that).attr("data-code");
        var price = $(that).attr("data-price-with-discount");
        $.FacebookPixel.AddToCart(productID, price);

        var params = {
            productID: productID,
            quantity: quantity,
        };

        return angular
            .element("#CartController")
            .scope()
            .vm.InsertWithParams(params)
            .then(
                function () {
                    $(that).attr("disabled", false);
                    window.location = "/Checkout/Checkout?fastBuy=true";
                },
                function (error) {
                    $(that).attr("disabled", false);
                    alert(error);
                }
            );
    },
    IsInCart: function (params) {
        if (!!angular.element(".cart-controller").scope()) {
            var isInCartResult = angular.element(".cart-controller").scope().vm.IsInCart(params);

            // Eğer isInCartResult Promise değilse, onu Promise haline getir
            if (typeof isInCartResult.then !== "function") {
                return Promise.resolve(isInCartResult);
            }
            // Zaten Promise ise direkt döndür
            return isInCartResult;
        } else {
            return Promise.resolve({});
        }
    },
    RemoveCartProduct: function (that, cartType, callback) {
        var cartProductId = $(that).attr("data-cart-product-id");

        var params = {
            Id: cartProductId,
        };
        return angular
            .element(".cart-controller")
            .scope()
            .vm.Delete(params, cartType)
            .then(function (data) {
                if (callback) {
                    callback(that);
                    return data;
                }
            });
    },
    RemoveCartAllProduct: function () {
        return angular
            .element(".cart-controller")
            .scope()
            .vm.DeleteAll()
            .then(function (data) {
                callback(that);
                return data;
            });
    },
    RemoveCartFavorite: function (that, cartType, callback) {
        var cartProductId = $(that).attr("data-cart-product-id");

        var params = {
            Id: cartProductId,
        };
        return angular
            .element(".cart-controller")
            .scope()
            .vm.Delete(params, cartType)
            .then(function (data) {
                callback(that);
                return data;
            });
    },
};

$.Product = {
    Search: function (that) {
        var noKeys = "";
        var noKeyIndex = noKeys.indexOf(that.which);
        if (noKeyIndex < 0) {
            $("#SearchResult").html("");
            var charVal = encodeURIComponent($(that).val());
            var charCulture = encodeURIComponent($(that).attr("Culture"));
            var charLength = charVal.length;
            if (charLength > 1) {
                $("#SearchResult").show();
                $("#SearchResult").html(
                    '<span class="loading" style="padding:70px 140px;">Ürünler filtreleniyor...</span>'
                );
                clearTimeout(window.getSearchTimer);
                window.getSearchTimer = setTimeout(
                    "$.Product.SearchItems('" +
                    charVal +
                    "','" +
                    charCulture +
                    "')",
                    500
                );
            } else {
                $("#SearchResult").hide();
            }
        }
    },
    SearchItems: function (charVal, charCulture) {
        $.ajax({
            url: (charCulture ? "/" + charCulture : "") + "/General/Search",
            type: "GET",
            cache: false,
            data: {
                search: charVal,
            },
            success: function (data) {
                $("#SearchResult").html(data);
            },
        });
    },
    Sort: function (formName, that) {
        $(".load-more-products .load-more-products-contain").show();
        if (!formName) {
            formName = "filter-desktop-form";
        }
        var url = window.location.href;

        var baseurl = url.split("?")[0];
        var SortProperty = that.split("_")[0];
        var SortType = that.split("_")[1];
        var PageSize = $.Url.QueryString("PageSize", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var SearchKey = $.Url.QueryString("SearchKey", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var serializedInputList = {};
        $.each($('[name="' + formName + '"]').serializeArray(), function () {
            serializedInputList[this.name] =
                (serializedInputList[this.name] || "") + this.value + ",";
        });
        var serializedInputString = "";
        $.each(serializedInputList, function (i, item) {
            serializedInputString += i + "=" + item.slice(0, -1) + "&";
        });
        var urlLast =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (PageSize ? "PageSize=" + PageSize + "&" : "") +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (SearchKey ? "SearchKey=" + SearchKey + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options ? optList : "") +
            serializedInputString.slice(0, -1);

        window.location = urlLast;
    },
    ChangeSize: function (formName, size) {
        $(".load-more-products .load-more-products-contain").show();
        if (!formName) {
            formName = "filter-desktop-form";
        }
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var PageSize = size;
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var SearchKey = $.Url.QueryString("SearchKey", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                optList += item.Id + "=" + item.value + "&";
            });
        }
        var serializedInputList = {};
        $.each($('[name="' + formName + '"]').serializeArray(), function () {
            serializedInputList[this.name] =
                (serializedInputList[this.name] || "") + this.value + ",";
        });
        var serializedInputString = "";
        $.each(serializedInputList, function (i, item) {
            serializedInputString += i + "=" + item.slice(0, -1) + "&";
        });
        var urlLast =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (PageSize ? "PageSize=" + PageSize + "&" : "") +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (SearchKey ? "SearchKey=" + SearchKey + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Options ? optList : "") +
            serializedInputString.slice(0, -1);
        window.location = urlLast;
    },
    FilterAll: function (formName, isPrice) {
        $(".load-more-products .load-more-products-contain").show();
        if (!formName) {
            formName = "filter-desktop-form";
        }
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var PageSize = $.Url.QueryString("PageSize", url);
        var urlisPrice = url.contains("MinPrice") || url.contains("MaxPrice");
        isPrice = isPrice ? isPrice : urlisPrice;
        var serializedInputList = {};
        $.each($('[name="' + formName + '"]').serializeArray(), function () {
            if (this.value != "") {
                if (isPrice == true) {
                    serializedInputList[this.name] =
                        (serializedInputList[this.name] || "") +
                        this.value +
                        ",";
                } else {
                    if (this.name != "MinPrice" && this.name != "MaxPrice") {
                        serializedInputList[this.name] =
                            (serializedInputList[this.name] || "") +
                            this.value +
                            ",";
                    }
                }
            }
        });
        var serializedInputString = "";
        $.each(serializedInputList, function (i, item) {
            if (item != "") {
                serializedInputString += i + "=" + item.slice(0, -1) + "&";
            }
        });
        var urlLast =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (PageSize ? "PageSize=" + PageSize + "&" : "") +
            serializedInputString.slice(0, -1);
        window.location = urlLast;
    },
    ClearAllFilter: function (e) {
        e.preventDefault();
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        window.location =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "");
    },
    ClearFilter: function (name, value) {
        var queryString = $.Url.AllQueryString();
        for (var i = 0; i < queryString.length; i++) {
            var item = queryString[i];
            if (item.Id == name) {
                for (var j = 0; j < item.value.length; j++) {
                    var subItem = item.value[j];
                    if (subItem == value) {
                        item.value.splice(item.value.indexOf(subItem), 1);
                    }
                }
            }
            if (item.value.length <= 0) {
                queryString.splice(queryString.indexOf(item), 1);
            }
        }
        window.location =
            window.location.pathname +
            "?" +
            _.trimEnd($.Url.ToQueryString(queryString), "&");
    },
    FilterByWizard: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var MinPrice = $.Url.QueryString("MinPrice", url);
        var MaxPrice = $.Url.QueryString("MaxPrice", url);
        var Brand = $.Url.QueryString("Brand", url);
        var Tags = $.Url.QueryString("Tags", url);
        var Collection = $.Url.QueryString("Collection", url);
        var Option = $(that).val();
        var OptionId = $(that).attr("data-id");
        var temp = $.Url.AllQueryString();
        var Options = $.Url.AllQueryString().filter(function (item) {
            return item.Id.includes("opt.");
        });
        var optList = "";
        if (Options.length > 0) {
            $.each(Options, function (index, item) {
                var optionEncoded = encodeURI(Option);
                if (
                    item.Id == "opt." + OptionId &&
                    !item.value.includes(optionEncoded)
                ) {
                    optList +=
                        item.Id + "=" + item.value + "," + optionEncoded + "&";
                } else if (
                    item.Id == "opt." + OptionId &&
                    item.value.includes(optionEncoded)
                ) {
                    var result = item.value
                        .replace("," + optionEncoded, "")
                        .replace(optionEncoded + ",", "")
                        .replace(optionEncoded, "");

                    if (!result) {
                        return true;
                    }
                    optList += item.Id + "=" + result + "&";
                } else {
                    optList += item.Id + "=" + item.value + "&";
                    if (index === Options.length - 1) {
                        optList +=
                            "opt." + OptionId + "=" + optionEncoded + "&";
                    }
                }
            });
        } else {
            optList = "opt." + OptionId + "=" + Option + "&";
        }
        var url =
            baseurl +
            "?" +
            (MinPrice ? "MinPrice=" + MinPrice + "&" : "") +
            (MaxPrice ? "MaxPrice=" + MaxPrice + "&" : "") +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Brand ? "Brand=" + Brand + "&" : "") +
            (Tags ? "Tags=" + Tags + "&" : "") +
            (Collection ? "Collection=" + Collection + "&" : "") +
            (Option ? optList : "");
    },
    CreateFilterByWizard: function (that) {
        $(that).nextAll().remove();

        var optionId = $(that).attr("option-id");
        var value = $(that).find("option:selected").val();

        if (!value || value == "...") {
            var url = window.location.href;
            var optionValue = $.Url.QueryString("opt." + optionId, url);
            if (optionValue) {
                $(that)
                    .find('[value="' + optionValue + '"]')
                    .attr("selected", "selected");
            }
        }

        var text = $(that).find("option:selected").text();
        var optionValueId = $(that)
            .find("option:selected")
            .attr("option-value-id");

        if (value) {
            $(that).attr("name", "opt." + optionId);
        }
        var subOptionList = $('[top-option-value-id="' + optionValueId + '"]');
        $(that)
            .closest(".filter-wizard")
            .find(".btn-wizard")
            .val(text)
            .attr("data-id", optionId);

        if (subOptionList.length) {
            var select =
                '<select class="form-control" option-id="' +
                $(subOptionList[0]).attr("option-id") +
                '" onchange="$.Product.CreateFilterByWizard(this)"><option value="">...</option>';
            for (var i = 0; i < subOptionList.length; i++) {
                var opt = subOptionList[i];
                select += opt.outerHTML;
            }
            select += "</select>";
            $(that).closest(".wizard-select-wrapper").append(select);

            $(
                '[option-id="' + $(subOptionList[0]).attr("option-id") + '"]'
            ).change();
        }
    },
    Click: function (that) { },
    Review: function (that) {
        $.ajax({
            url: "/General/Review",
            data: new FormData($(that).closest("form")[0]),
            type: "POST",
            processData: false,
            contentType: false,
            success: function (result) {
                //$(".btn-do-review").click();
                $(".reviewRate").rateYo("rating", 0);
                $(that).closest("form").find("input[name='Title']").val("");
                $(that).closest("form").find("textarea[name='Text']").val("");
                $(that).closest("form").find("input[name='Files']").val("");
                var review = $(that).closest("form").find(".ReviewSuccessText");
                $(review).fadeIn("slow").delay(3000).fadeOut("fast");
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                var review = $(that).closest("form").find(".ReviewFailure");
                $(review).fadeIn("slow").delay(3000).fadeOut("fast");
            },
        });
    },
    PlayVideo: function () {
        setTimeout(() => {
            var containers = document.querySelectorAll(".productbox-video");
            if (containers && containers.length > 0) {
                containers.forEach(function (container) {
                    container.addEventListener("mouseenter", function () {
                        this.querySelector("video").play();
                        container.addEventListener("mouseleave", function () {
                            this.querySelector("video").pause();
                        });
                    });
                });
            }
        }, "1000");
    },
};

$.Url = {
    QueryString: function (name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    AllQueryString: function () {
        var vars = [],
            hash;
        var q = document.URL.split("?")[1];
        if (q != undefined) {
            q = q.split("#")[0];
            q = q.split("&");
            for (var i = 0; i < q.length; i++) {
                hash = q[i].split("=");
                if (hash[0] && hash[1]) {
                    vars.push({
                        Id: hash[0],
                        value: hash[1].split(",").map(function (item) {
                            return decodeURI(item).replace("+", " ");
                        }),
                    });
                }
            }
        }
        return vars;
    },
    ToQueryString: function (list) {
        var queryString = "";
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var subQueryString = item.Id + "=" + item.value.toString() + "&";
            queryString += subQueryString;
        }
        return queryString.slice(0, queryString.length - 1);
    },
};

$.Review = {
    LoadMore: function (that, callback) {
        var Date = $(that).attr("data-date");
        var PId = $(that).attr("data-product");
        var LMore = $(that);
        LMore.before('<img src="/images/loader.gif" class="yukleniyor" />');
        LMore.hide();
        $.ajax({
            type: "POST",
            url: "/General/LoadMore",
            data: {
                LastDate: Date,
                ProductId: PId,
            },
            cache: false,
            success: function (data) {
                if (data.LastDate === -1) {
                    LMore.before("<span>Başka Kayıt Bulunamadı</span>");
                    $(".yukleniyor").remove();
                    LMore.remove();
                    return;
                }
                $.each(data.m, function (i, item) {
                    var UserDate = moment(item.InsertDate).format("DD.MM.YYYY");
                    $(".reviewGen").append(
                        '<div class="reviewList" data-date="' +
                        item.InsertDate +
                        '" data-product="' +
                        item.ProductId +
                        '">' +
                        '<div class="reviewL">' +
                        '<div class="reviewInfo">' +
                        '<div class="reviewHead">' +
                        "<span>" +
                        item.ReviewTitle +
                        "</span>" +
                        '<span class="reviewHead-user">' +
                        item.User.Name +
                        " " +
                        item.User.Surname +
                        " - " +
                        UserDate +
                        "</span>" +
                        "</div>" +
                        '<div class="listRate" data-value=' +
                        item.Rating +
                        '></div><div class="reviewMessage">' +
                        item.ReviewText +
                        "</div>" +
                        "</div>" +
                        "</div>" +
                        "</div>"
                    );
                    $(".reviewGen .reviewList:last").fadeIn("slow");

                    $(".listRate").each(function (i, obj) {
                        var ratingValue = obj.attributes["data-value"].value;
                        if (ratingValue !== null) {
                            $(obj).rateYo({
                                starWidth: "20px",
                                rating: ratingValue,
                                readOnly: true,
                            });
                        }
                    });
                });
                LastDate(data.LastDate);

                function LastDate(load) {
                    var date;
                    if (load === null) {
                        date = $(".reviewGen .reviewList:last").attr(
                            "data-date"
                        );
                    } else {
                        date = load;
                    }
                    $(".load").attr({
                        "data-date": date,
                        "data-product": data.ProductId,
                    });
                }
                $(".yukleniyor").remove();
                LMore.show();
            },
        });
        return false;
    },
    Sort: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = that.split("_")[0];
        var SortType = that.split("_")[1];
        var PageIndex = $.Url.QueryString("PageIndex", url);
        var Rates = $.Url.QueryString("Rates", url);

        window.location =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Rates ? "Rates=" + Rates + "&" : "");
    },
    FilterByRate: function (that) {
        var url = window.location.href;
        var baseurl = url.split("?")[0];
        var SortProperty = $.Url.QueryString("SortProperty", url);
        var SortType = $.Url.QueryString("SortType", url);
        var QueryRates = $.Url.QueryString("Rates", url);
        var Rates = "";
        if (QueryRates) {
            if (QueryRates.includes($(that).val())) {
                Rates = QueryRates.replace("," + $(that).val(), "")
                    .replace($(that).val() + ",", "")
                    .replace($(that).val(), "");
            } else {
                Rates = (QueryRates ? QueryRates + "," : "") + $(that).val();
            }
        } else {
            Rates = $(that).val();
        }
        window.location =
            baseurl +
            "?" +
            (SortProperty ? "SortProperty=" + SortProperty + "&" : "") +
            (SortType ? "SortType=" + SortType + "&" : "") +
            (Rates ? "Rates=" + Rates + "&" : "");
    },
};

$.Favorite = {
    Like: function (that) {
        $.ajax({
            type: "POST",
            url: "/General/Favorite/Like",
            data: {
                Id: $(that).attr("data-fav"),
            },
            cache: false,
            success: function (data) {
                $(that)
                    .closest(".comment-like-dislike")
                    .append("<span>Teşekkür Ederiz</span>");
                $(that).closest(".btn-group").remove();
            },
        });
    },
    Dislike: function (that) {
        $.ajax({
            type: "POST",
            url: "/General/Favorite/Dislike",
            data: {
                Id: $(that).attr("data-fav"),
            },
            cache: false,
            success: function (data) {
                $(that)
                    .closest(".comment-like-dislike")
                    .append("<span> Teşekkür Ederiz</span>");
                $(that).closest(".btn-group").remove();
            },
        });
    },
};

$.Blog = {
    Search: function (that) {
        var noKeys = "";
        var noKeyIndex = noKeys.indexOf(that.which);
        if (noKeyIndex < 0) {
            $("#SearchResult").html("");
            var charVal = encodeURIComponent($(that).val());
            var charLength = charVal.length;

            if (charLength > 1) {
                $("#SearchResult").show();
                $("#SearchResult").html(
                    '<span class="loading" style="padding:70px 140px;">Blog Postları filtreleniyor...</span>'
                );

                clearTimeout(getSearchTimer);

                var getSearchTimer = setTimeout(
                    "$.Blog.SearchItems('" + charVal + "')",
                    1500
                );
            } else {
                $("#SearchResult").hide();
            }
        }
    },
    SearchItems: function (charVal) {
        $.ajax({
            url: "/General/BlogPostSearch",
            type: "GET",
            cache: false,
            data: {
                search: charVal,
            },
            success: function (data) {
                $("#SearchResult").html(data);
            },
        });
    },
};

$.Util = {
    ToNumber: function (item) {
        if (item) {
            var val = item.toString().replace(",", ".");
            return Number(val);
        } else {
            return Number("0");
        }
    },

    ToString: function (item) {
        var val = item.toString().replace(".", ",");
        return val;
    },

    ToFloat: function (item) {
        if (item) {
            return parseFloat(item.toString().replace(",", "."));
        } else {
            return parseFloat("0");
        }
    },

    ToPrecision: function (item) {
        return parseFloat(item.toFixed(2).split(".")[1]);
    },

    ToFloor: function (item) {
        return parseFloat((item + "").split(".")[0]);
    },

    ToFillZero: function (item, width) {
        return item.length >= width
            ? item
            : (new Array(width).join("0") + item).slice(-width);
    },

    ByString: function (o, s) {
        s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
        s = s.replace(/^\./, ""); // strip a leading dot
        var a = s.split(".");
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    },

    GroupBy: function (xs, key) {
        return xs.reduce(function (rv, x) { }, {});
    },
    ToConvert: function (item) {
        if (item % 1 != 0) {
            //Decimal değer kontrolü
            var val = item.toFixed(2);
            return val;
        } else {
            return item;
        }
    },
    NumberWithCommas: function (item) {
        return item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
};

$.Cookie = {
    setCookie: function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie =
            cname + "=" + (cvalue || "") + ";" + expires + ";path=/";
    },

    getCookie: function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    deleteCookie: function (name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
};

$.Analytics = {
    View_Item_List: function (product) {
        if (typeof gtag !== "undefined") {
            gtag("event", "view_item_list", {
                items: [
                    {
                        id: product.Id,
                        name: product.Name,
                        list_name: "List",
                        brand: product.Brand,
                        category: product.category,
                        variant: "",
                        list_position: product.DisplayOrder,
                        quantity: product.Quantity,
                        price: product.Price,
                    },
                ],
            });
        }
    },
    Select_Content: function (that) {
        if (typeof gtag !== "undefined") {
            localStorage.setItem("data", JSON.stringify(that).toString());
            if (dataLayer) {
                dataLayer.push({
                    event: "productClick",
                    ecommerce: {
                        click: {
                            actionField: { list: that.list_name },
                            products: that,
                        },
                    },
                    eventCallback: function () {
                        document.location = that.link;
                    },
                });
            }
        }

        //if (gtag) {
        //    gtag("event", "view_item", {
        //        items: [
        //            {
        //                id: product.Id,
        //                name: product.Name,
        //                list_name: "List",
        //                category: product.category,
        //                variant: "",
        //                brand: product.Brand,
        //                quantity: product.Quantity,
        //                price: product.Price,
        //            },
        //        ],
        //    });
        //}
    },
    View_Item: function (product) {
        if (typeof gtag !== "undefined" && product) {
            var productsData = [];
            for (var i = 0; i < product.length; i++) {
                productsData[i] = {
                    id: product[i].id,
                    name: product[i].Name,
                    brand: product[i].Brand,
                    category: product[i].Category,
                    variant: product[i].Name,
                    list_position: product[i].DisplayOrder,
                    quantity: product[i].DefaultQuantity,
                    price: product[i].Price,
                    aggregateRating: product[i].Price,
                    priceValidUntil: "",
                    url: window.location.href,
                    sku: product[i].Id,
                    rewiev: product[i].rewiev,
                };
            }

            gtag("event", "view_item", {
                items: productsData,
            });
        } else {
        }
    },
    Add_To_Cart: function (product) {
        if (typeof gtag !== "undefined") {
            gtag("event", "add_to_cart", {
                items: [
                    {
                        id: product.Id,
                        name: product.name,
                        list_name: "Search Results",
                        brand: product.Brand,
                        category: product.category,
                        variant: product.variant,
                        quantity: product.quantity,
                        price: product.price,
                    },
                ],
            });
        } else {
        }

        if (dataLayer) {
            dataLayer.push({
                event: "addToCart",
                ecommerce: {
                    currencyCode: product.currency,
                    add: {
                        products: [
                            {
                                name: product.name,
                                id: product.id,
                                price: product.price,
                                brand: product.brand,
                                category: product.category,
                                variant: product.variant,
                                quantity: product.quantity,
                            },
                        ],
                    },
                },
            });
        }
    },
    Remove_From_Cart: function (cart) {
        var product = cart.Product;

        if (product) {
            var analticsData = product.AnalyticsData;

            var analytics;

            analytics = analticsData
                ? JSON.parse(analticsData).products[0]
                : null;

            if (typeof gtag !== "undefined") {
                gtag("event", "remove_from_cart", {
                    items: [
                        {
                            id: product.Code,
                            name: product.Name,
                            list_name: "Search Results",
                            brand: analytics ? analytics.brand : null,
                            category: analytics ? analytics.category : null,
                            variant: cart.VariantValues,
                            quantity: cart.Quantity,
                            price: product.PriceWithDiscount,
                        },
                    ],
                });
            }
            if (dataLayer) {
                dataLayer.push({
                    event: "removeFromCart",
                    ecommerce: {
                        remove: {
                            products: [
                                {
                                    name: product.Name,
                                    id: product.Code,
                                    price: product.PriceWithDiscount.toFixed(2),
                                    brand: analytics ? analytics.brand : null,
                                    category: analytics
                                        ? analytics.category
                                        : null,
                                    variant:
                                        cart.VariantValues === "[]"
                                            ? !product.ProductVariantString
                                                ? null
                                                : product.ProductVariantString
                                            : cart.VariantValues,
                                    quantity: cart.Quantity,
                                },
                            ],
                        },
                    },
                });
            }
        }
    },
    //View_Promotion: function (that) {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'view_promotion', {
    //			"promotions": [
    //				{
    //					"id": "abc123",
    //					"name": "summer_promo"
    //				},
    //				{
    //					"id": "xyz987",
    //					"name": "spring savings"
    //				}
    //			]
    //		});
    //	}
    //},
    //Promotion_Select_Content: function (that) {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'select_content', {
    //			"promotions": [
    //				{
    //					"id": "abc123",
    //					"name": "summer_promo"
    //				}
    //			]
    //		});
    //	}
    //},
    Begin_Checkout: function (product) {
        var products = product.CartProduct;
        var analyticsProduct = [];
        var gtagProduct = [];

        products.forEach(function (element) {
            var analticsData = element.Product.AnalyticsData;

            var analytics;

            analytics = analticsData
                ? JSON.parse(analticsData).products[0]
                : null;

            analyticsProduct.push({
                name: element.Product.Name,
                id: element.Product.Code,
                price: element.TotalPriceWithDiscount.toFixed(2),
                brand: analytics ? analytics.brand : null,
                category: analytics ? analytics.category : null,
                variant: !(analytics
                    ? analytics.variant
                    : element.variantValues)
                    ? element.Product.ProductVariantString
                    : analytics
                        ? analytics.variant
                        : element.variantValues,
                quantity: element.Quantity,
            });

            gtagProduct.push({
                id: element.Product.Code,
                name: element.Product.Name,
                list_name: "Search Results",
                brand: analytics ? analytics.brand : null,
                category: analytics ? analytics.category : null,
                variant: !(analytics
                    ? analytics.variant
                    : element.variantValues)
                    ? element.Product.ProductVariantString
                    : analytics
                        ? analytics.variant
                        : element.variantValues,
                list_position: product.DisplayOrder,
                quantity: element.Quantity,
                price: element.TotalPriceWithDiscount.toFixed(2),
            });
        });

        // if (gtag) {
        //     gtag("event", "begin_checkout", {
        //         items: gtagProduct,
        //         coupon: "",
        //     });
        // }
        if (dataLayer) {
            dataLayer.push({
                event: "checkout",
                ecommerce: {
                    checkout: {
                        actionField: { step: 1 },
                        products: analyticsProduct,
                    },
                },
            });
        }
    },
    Checkout_Progress: function (product, step) {
        var products = product.CartProduct;
        var analyticsProduct = [];
        var gtagProduct = [];

        products.forEach(function (element) {
            var analticsData = element.Product.AnalyticsData;

            var analytics;

            analytics = analticsData
                ? JSON.parse(analticsData).products[0]
                : null;

            analyticsProduct.push({
                name: element.Product.Name,
                id: element.Product.Code,
                price: element.TotalPriceWithDiscount.toFixed(2),
                brand: analytics ? analytics.brand : null,
                category: analytics ? analytics.category : null,
                variant: !(analytics
                    ? analytics.variant
                    : element.variantValues)
                    ? element.Product.ProductVariantString
                    : analytics
                        ? analytics.variant
                        : element.variantValues,
                quantity: element.Quantity,
            });

            gtagProduct.push({
                id: element.Product.Code,
                name: element.Product.Name,
                list_name: "Search Results",
                brand: analytics ? analytics.brand : null,
                category: analytics ? analytics.category : null,
                variant: !(analytics
                    ? analytics.variant
                    : element.variantValues)
                    ? element.Product.ProductVariantString
                    : analytics
                        ? analytics.variant
                        : element.variantValues,
                list_position: product.DisplayOrder,
                quantity: element.Quantity,
                price: element.TotalPriceWithDiscount.toFixed(2),
            });
        });

        if (typeof gtag !== "undefined") {
            gtag("event", "checkout_progress", {
                items: gtagProduct,
                coupon: "",
            });
        }
        if (dataLayer) {
            dataLayer.push({
                event: "checkout",
                ecommerce: {
                    checkout: {
                        actionField: { step: step },
                        products: analyticsProduct,
                    },
                },
            });
        }
    },
    //Set_Checkout_Option: function (that) {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'set_checkout_option', {
    //			"checkout_step": 1,
    //			"checkout_option": "shipping method",
    //			"value": "USPS"
    //		});
    //	}
    //},
    Purchase: function (product, orderRes) {
        var dataLayerData = [];
        if (typeof gtag !== "undefined") {
            var productsData = [];
            for (var i = 0; i < product.products.length; i++) {
                productsData[i] = {
                    id: product.products[i].Code,
                    name: product.products[i].Name,
                    brand: product.products[i].Brand,
                    category: product.products[i].category,
                    variant: product.products[i].variant,
                    list_position: product.products[i].DisplayOrder,
                    quantity: product.products[i].Quantity,
                    price: product.products[i].PriceWithDiscount,
                    list_name: "Search Results",
                };
                dataLayerData.push({
                    name: product.products[i].Name,
                    id: product.products[i].Code,
                    price: product.products[i].PriceWithDiscount,
                    brand: product.products[i].Brand,
                    category: product.products[i].category,
                    variant: product.products[i].variant,
                    quantity: product.products[i].DefaultQuantity,
                });
            }
            gtag("event", "purchase", {
                transaction_id: orderRes,
                affiliation: product.affiliation,
                value: product.priceWithDiscount, //toplam sepet miktarı
                currency: "TRY",
                tax: 0, //vergi
                shipping: 0, //kargo ücreti
                items: productsData,
            });
            if (dataLayer) {
                dataLayer.push({
                    event: "purchase",
                    ecommerce: {
                        checkout: {
                            actionField: {
                                id: orderRes,
                                affiliation: product.affiliation,
                                revenue: product.priceWithDiscount,
                            },
                            products: dataLayerData,
                        },
                    },
                });
            }
        }
    },
    //Refund: function () {
    //	if (GoogleAnalyticsCode) {
    //		gtag('event', 'refund', {
    //			"transaction_id": "79.18502354114992",
    //			"affiliation": "Google online store",
    //			"value": 23.07,
    //			"currency": "USD",
    //			"tax": 1.24,
    //			"shipping": 0,
    //			"items": [
    //				{
    //					"id": "P12345",
    //					"name": "Android Warhol T-Shirt",
    //					"list_name": "Search Results",
    //					"brand": "Google",
    //					"category": "Apparel/T-Shirts",
    //					"variant": "Black",
    //					"list_position": 1,
    //					"quantity": 2,
    //					"price": '2.0'
    //				},
    //				{
    //					"id": "P67890",
    //					"name": "Flame challenge TShirt",
    //					"list_name": "Search Results",
    //					"brand": "MyBrand",
    //					"category": "Apparel/T-Shirts",
    //					"variant": "Red",
    //					"list_position": 2,
    //					"quantity": 1,
    //					"price": '3.0'
    //				}
    //			]
    //		});
    //	}
    //}
};

$.Criteo = {
    View_Item: function (product, userMail, CriteoAccountCode) {
        window.criteo_q = window.criteo_q || [];

        var mail = new String(userMail).valueOf();

        var deviceType = /iPad/.test(navigator.userAgent)
            ? "t"
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
                navigator.userAgent
            )
                ? "m"
                : "d";
        window.criteo_q.push(
            { event: "setAccount", account: CriteoAccountCode },
            { event: "setEmail", email: mail },
            { event: "setZipcode", zipcode: "" },
            { event: "setSiteType", type: deviceType },
            { event: "viewItem", item: product.Code }
        );
    },

    View_Item_List: function (product, userMail, CriteoAccountCode) {
        window.criteo_q = window.criteo_q || [];

        var mail = new String(userMail).valueOf();

        var productCodes = [];

        if (product)
            product.forEach((element) => productCodes.push(element.Code));

        var mail = new String(userMail).valueOf();

        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent)
            ? "t"
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
                navigator.userAgent
            )
                ? "m"
                : "d";
        window.criteo_q.push(
            { event: "setAccount", account: CriteoAccountCode },
            { event: "setEmail", email: mail },
            { event: "setZipcode", zipcode: "" },
            { event: "setSiteType", type: deviceType },
            { event: "viewList", item: productCodes }
        );
    },

    Home_View: function (userMail, CriteoAccountCode) {
        window.criteo_q = window.criteo_q || [];

        var mail = new String(userMail).valueOf();

        var deviceType = /iPad/.test(navigator.userAgent)
            ? "t"
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
                navigator.userAgent
            )
                ? "m"
                : "d";
        window.criteo_q.push(
            { event: "setAccount", account: CriteoAccountCode },
            { event: "setEmail", email: mail },
            { event: "setZipcode", zipcode: "" },
            { event: "setSiteType", type: deviceType },
            { event: "viewHome" }
        );
    },

    Purchase: function (product, orderRes) {
        var userMail = product.userEmail;

        userMail = new String(userMail).valueOf();

        var productsData = [];
        for (var i = 0; i < product.products.length; i++) {
            productsData[i] = {
                id: product.products[i].Code,
                price: Number(
                    parseFloat(
                        product.products[i].PriceWithDiscount.replace(
                            ".",
                            ""
                        ).replace(",", ".")
                    ).toFixed(2)
                ),
                quantity: product.products[i].DefaultQuantity,
            };
        }

        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent)
            ? "t"
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
                navigator.userAgent
            )
                ? "m"
                : "d";
        window.criteo_q.push(
            { event: "setAccount", account: product.criteoCode },
            { event: "setEmail", email: userMail },
            { event: "setZipcode", zipcode: "" },
            { event: "setSiteType", type: deviceType },
            {
                event: "trackTransaction",
                id: orderRes,
                item: productsData,
            }
        );
    },

    Basket: function (cart, CriteoAccountCode) {
        window.criteo_q = window.criteo_q || [];
        var userMail = "";

        if (cart.User) userMail = CryptoJS.MD5(cart.User.Email).toString();

        var productsData = [];

        if (cart) {
            cart.CartProduct.forEach((element) =>
                productsData.push({
                    id: element.Product.Code,
                    price: Number(element.TotalPriceWithDiscount.toFixed(2)),
                    quantity: element.Quantity,
                })
            );
        }

        var deviceType = /iPad/.test(navigator.userAgent)
            ? "t"
            : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
                navigator.userAgent
            )
                ? "m"
                : "d";
        window.criteo_q.push(
            { event: "setAccount", account: CriteoAccountCode },
            { event: "setEmail", email: userMail },
            { event: "setZipcode", zipcode: "" },
            { event: "setSiteType", type: deviceType },
            { event: "viewBasket", item: productsData }
        );
    },
};

$.FacebookPixel = {
    PageView: function () {
        if (fbq) {
            fbq("track", "PageView");
        }
    },
    ViewContent: function (product) {
        if (fbq) {
            if (product && product.length === undefined) {
                var prc = parseFloat(product.PriceWithDiscount.replace('.', '').replace(',', '.')).toFixed(2);
                fbq("track", "ViewContent", {
                    content_type: "product",
                    content_ids: [product.Code],
                    content_name: product.Name,
                    content_category: product.category,
                    currency: "TRY",
                    url: product.url,
                    value: prc,
                });
            } else if (product && product.length >= 1) {
                var prc = parseFloat(product[0].PriceWithDiscount.replace('.', '').replace(',', '.')).toFixed(2);
                fbq("track", "ViewContent", {
                    content_type: "product_group",
                    content_ids: [product[0].Code],
                    content_name: product[0].Name,
                    content_category: product[0].category,
                    currency: "TRY",
                    url: product.url,
                    value: prc,
                });
            }
        }
    },
    AddToCart: function (productID, price) {
        if (fbq) {
            fbq("track", "PageView");
            var prc = parseFloat(price.replace('.', '').replace(',', '.')).toFixed(2);
            fbq("track", "AddToCart", {
                content_ids: [productID],
                content_type: "product",
                value: prc,
                currency: "TRY",
            });
        }
    },
    Purchase: function (resultData) {
        if (fbq) {
            var productsData = [];
            for (var i = 0; i < resultData.products.length; i++) {
                productsData[i] = {
                    id: resultData.products[i].Code,
                    quantity: resultData.products[i].Quantity,
                };
            }
            fbq("track", "PageView");
            fbq("track", "Purchase", {
                value: resultData.price,
                currency: resultData.currency || "TRY",
                contents: productsData,
                content_type: "product",
            });
        }
    },
};

$.Integration = {
    Purchase: function (result, orderResult, settings) {
        var resultData = JSON.parse(result);
        $.FacebookPixel.Purchase(resultData);
        $.Analytics.Purchase(resultData, orderResult);
        if (
            settings != null &&
            typeof settings.CriteoAccountCode !== "undefined" &&
            !!settings.CriteoAccountCode
        ) {
            $.Criteo.Purchase(resultData, orderResult);
        }
    },
};

$.Shipment = {
    ShipmentStatus: function (salesOrderId, shipmentProviderId) {
        $.ajax({
            method: "GET",
            url:
                "/Account/ShipmentStatus/" +
                salesOrderId +
                "/" +
                shipmentProviderId,
            cache: false,
        })
            .done(function (result) {
                $("#ShipmentStatusModal").modal("show");
                if (result.length == 0) {
                    document.getElementById("CargoNorWorking").style.display =
                        "block";
                    document.getElementById("statusTable").style.display =
                        "none";
                } else {
                    document.getElementById("CargoNorWorking").style.display =
                        "none";
                    document.getElementById("statusTable").style.display =
                        "block";

                    var tbody = $("#statusTable > tbody");
                    tbody.html("");
                    $("#ShipmentStatusModal .modal-body").find("a").remove();
                    var modalBody = $("#ShipmentStatusModal .modal-body");
                    var tr = $("<tr>");
                    tr.append(
                        $("<td>", {
                            text: result.CargoTrackingNumber,
                        })
                    );
                    tr.append(
                        $("<td>", {
                            text: result.ReceiverName,
                        })
                    );
                    tr.append(
                        $("<td>", {
                            text: result.ResultMessage,
                        })
                    );
                    tr.append(
                        $("<td>", {
                            text: result.SenderName,
                        })
                    );
                    tr.append(
                        $("<td>", {
                            text: result.TotalCargo,
                        })
                    );
                    tr.append(
                        $("<td>", {
                            text: result.TotalDesiKg,
                        })
                    );
                    tr.append(
                        $("<td>", {
                            text: result.PackageType,
                        })
                    );
                    tbody.append(tr);
                    modalBody.append(
                        $(
                            "<a target='_blank' href='" +
                            result.ShipmentTrackingUrl +
                            "' type='button' class='btn btn-success'>Kargo Detayı</a>"
                        )
                    );
                }
            })
            .fail(function (error) {
                $("#errorModalAlertDiv").modal("show");
                $("#errorModalAlertDiv .error-modal-content").html(
                    shipmentError
                );
            });
    },
    ShipmentStatusV2: function (shipmentId) {
        $.ajax({
            method: "GET",
            url: "/webapi/v2/Account/ShipmentStatus/" + shipmentId,
            cache: false,
        }).done(function (result) {
            $("#ShipmentStatusModal").modal("show");
            if (result.Data.length == 0) {
                document.getElementById("CargoNorWorking").style.display = "block";
                document.getElementById("statusTable").style.display = "none";
            } else {
                document.getElementById("CargoNorWorking").style.display = "none";
                document.getElementById("statusTable").style.display = "block";
                var tbody = $("#statusTable > tbody");
                tbody.html("");
                $("#ShipmentStatusModal .modal-body").find("a").remove();
                var modalBody = $("#ShipmentStatusModal .modal-body");
                var tr = $("<tr>");
                tr.append(
                    $("<td>", {
                        text: result.Data.CargoTrackingNumber,
                    })
                );
                tr.append(
                    $("<td>", {
                        text: result.Data.ReceiverName,
                    })
                );
                tr.append(
                    $("<td>", {
                        text: result.Data.ResultMessage,
                    })
                );
                tr.append(
                    $("<td>", {
                        text: result.Data.SenderName,
                    })
                );
                tr.append(
                    $("<td>", {
                        text: result.Data.TotalCargo,
                    })
                );
                tr.append(
                    $("<td>", {
                        text: result.Data.TotalDesiKg,
                    })
                );
                tr.append(
                    $("<td>", {
                        text: result.Data.PackageType,
                    })
                );
                tbody.append(tr);
                if (result.Data.ShipmentTrackingUrl) {
                    modalBody.append(
                        $(
                            "<a target='_blank' href='" +
                            result.Data.ShipmentTrackingUrl +
                            "' type='button' class='btn btn-success'>Kargo Detayı</a>"
                        )
                    );
                } else if (result.Data.CargoTrackingUrl) {
                    modalBody.append(
                        $(
                            "<a target='_blank' href='" +
                            result.Data.CargoTrackingUrl +
                            "' type='button' class='btn btn-success'>Kargo Detayı</a>"
                        )
                    );
                }
            }
        })
            .fail(function (error) {
                $("#errorModalAlertDiv").modal("show");
                $("#errorModalAlertDiv .error-modal-content").html(
                    shipmentError
                );
            });
    }
};
